// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/AlignItero/Content/Content/download-mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Images_Content_Content_Content_Content_AlignItero_Content_Content($scan_id: uuid!) {
  apps_align_scan_request_update(scan_id: $scan_id) {
    id
    status
  }
}

`